export enum UICardTheme {
    Pink = 'pink',
    Petrol = 'petrol',
    PetrolVariant = 'petrol-variant',
    PinkHeader = 'pink-header',
    WhiteAndBlue = 'white-blue',
    WhiteAndPetrolLightest = 'white-petrol-lightest',
}
